import { AvailabilityModel, IAvailability } from "@core/models";

export const scheduleMock = [
  new AvailabilityModel({
    [IAvailability.label]: "Lundi",
    [IAvailability.morning]: true,
    [IAvailability.afternoon]: false,
    [IAvailability.evening]: true,
    [IAvailability.night]: false,
    [IAvailability.dayId]: 1,
  }),
  new AvailabilityModel({
    [IAvailability.label]: "Mardi",
    [IAvailability.morning]: true,
    [IAvailability.afternoon]: false,
    [IAvailability.evening]: true,
    [IAvailability.night]: false,
    [IAvailability.dayId]: 2,
  }),
  new AvailabilityModel({
    [IAvailability.label]: "Mercredi",
    [IAvailability.morning]: true,
    [IAvailability.afternoon]: false,
    [IAvailability.evening]: true,
    [IAvailability.night]: false,
    [IAvailability.dayId]: 3,
  }),
  new AvailabilityModel({
    [IAvailability.label]: "Jeudi",
    [IAvailability.morning]: true,
    [IAvailability.afternoon]: false,
    [IAvailability.evening]: true,
    [IAvailability.night]: false,
    [IAvailability.dayId]: 4,
  }),
  new AvailabilityModel({
    [IAvailability.label]: "Vendredi",
    [IAvailability.morning]: true,
    [IAvailability.afternoon]: false,
    [IAvailability.evening]: true,
    [IAvailability.night]: false,
    [IAvailability.dayId]: 5,
  }),
  new AvailabilityModel({
    [IAvailability.label]: "Samedi",
    [IAvailability.morning]: true,
    [IAvailability.afternoon]: false,
    [IAvailability.evening]: true,
    [IAvailability.night]: false,
    [IAvailability.dayId]: 6,
  }),
  new AvailabilityModel({
    [IAvailability.label]: "Dimanche",
    [IAvailability.morning]: true,
    [IAvailability.afternoon]: false,
    [IAvailability.evening]: true,
    [IAvailability.night]: false,
    [IAvailability.dayId]: 7,
  }),
];
